import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Chinese from "./i18n_zh.json";
import Dutch from "./i18n_nl.json";
import English from "./i18n_en.json";
import French from "./i18n_fr.json";
import German from "./i18n_de.json";
import Italian from "./i18n_it.json";
import Japanese from "./i18n_ja.json";
import Korean from "./i18n_ko.json";
import Polish from "./i18n_pl.json";
import Portuguese from "./i18n_pt.json";
import Russian from "./i18n_ru.json";
import Spanish from "./i18n_es.json";
import Turkish from "./i18n_tr.json";

export const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
};

i18n
    .use(initReactI18next)
    .init({
        resources: {
            zh: Chinese,
            nl: Dutch,
            en: English,
            fr: French,
            de: German,
            it: Italian,
            ja: Japanese,
            ko: Korean,
            pl: Polish,
            pt: Portuguese,
            ru: Russian,
            es: Spanish,
            tr: Turkish
        },
        fallbackLng: "en",
        debug: false,

        ns: ["translations"],
        defaultNS: "translations",

        keySeparator: false,

        interpolation: {
            escapeValue: false
        }
    });

export default i18n;
